import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ProposalService } from 'src/app/services/proposal.service';

@Component({
    selector: 'app-tabNavigation',
    templateUrl: './tab-navigation.component.html',
    styleUrls: ['./tab-navigation.component.scss'],
})
export class TabNavigationComponent implements OnInit {
    selectedTabIndex: number;
    highestTabIndex: number = 0;
    @Output() tabChangeRequested = new EventEmitter<number>();

    constructor(private proposalService: ProposalService) {}

    ngOnInit() {
        this.proposalService.highestTabIndex.subscribe(
            index => (this.highestTabIndex = index)
        );
        this.proposalService.proposalTabsSelectedIndex.subscribe(
            index => (this.selectedTabIndex = index)
        );
    }

    switchTab(increaseOrDecrease: number) {
        if (increaseOrDecrease > 0) {
            if (this.selectedTabIndex < this.highestTabIndex - 1) {
                this.selectedTabIndex++;
            }
        } else {
            if (this.selectedTabIndex > 0) {
                this.selectedTabIndex--;
            }
        }
        this.proposalService.RefreshProposalTabsSelectedIndex(
            this.selectedTabIndex
        );
    }
}
